<div class="states-list rounded shadow pt-6 pb-4 px-4">
    <div class="title border-b text-sm font-semibold pb-2">US Legal Bettting</div>               
    <ul role="list" class="list-none mt-2 ml-0">
        <li class="cursor-pointer text-sm font-medium capitalize" *ngFor="let item of items">
            <a class="block py-1 text-gray-600 " href="{{ item.link }}" routerLink="{{ item.link }}">{{ item.name }} Sports Betting</a>
        </li>
        <li class="cursor-pointer text-sm font-medium capitalize">
            <a class="flex items-center gap-4 py-1 text-highlight-100" href="/betting" routerLink="/betting">
                See all US sports betting
                <fa-icon class="flex" [icon]="faArrowRightLong"></fa-icon>
            </a>
        </li>
    </ul>
</div>
